const setCookie = (name, value, days) => {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toGMTString()}`;
    }
    // eslint-disable-next-line no-undef
    document.cookie = `${name}=${value}${expires}; path=/`;
};

const getCookie = (name) => {
    name = `${name}=`;
    // eslint-disable-next-line no-undef
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
};

const Cookies = {
    Country: 'country',
    Currency: 'currency',
    GeoCountry: 'geo-country',
    VisitedCountry: 'has-visited-country',
    InApp: 'in_app',
};

export default Cookies;
export { getCookie, setCookie };
